
import React from 'react';
import { Card } from "@/components/ui/card";
import { ProviderForm } from './steps/ProviderForm';
import { UserAssignmentForm } from './steps/UserAssignmentForm';
import { LeadAccountForm } from './steps/LeadAccountForm';
import { StrategyForm } from './steps/StrategyForm';
import { AccountForm } from './steps/AccountForm';
import { WizardSummary } from './steps/WizardSummary';
import { WizardHeader } from './WizardHeader';
import { WizardFormData } from '@/hooks/admin/provider-wizard/types';

interface WizardStepRendererProps {
  currentStep: number;
  stepLabels: string[];
  totalSteps: number;
  formData: WizardFormData;
  isSubmitting: boolean;
  handleStepSubmit: (data: Partial<WizardFormData>, isValid?: boolean) => void;
  setIsFormValid: (isValid: boolean) => void;
  handleNext: () => Promise<boolean>;
}

export const WizardStepRenderer = ({
  currentStep,
  stepLabels,
  totalSteps,
  formData,
  isSubmitting,
  handleStepSubmit,
  setIsFormValid,
  handleNext
}: WizardStepRendererProps) => {
  
  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <ProviderForm 
                onSubmit={(data, isValid = true) => {
                  handleStepSubmit(data, isValid);
                  setIsFormValid(isValid);
                }} 
                initialData={formData.provider} 
              />;
      case 1:
        return <UserAssignmentForm 
                onSubmit={(data, isValid = false) => {
                  handleStepSubmit(data, isValid);
                  setIsFormValid(isValid);
                }} 
                initialData={formData.user} 
              />;
      case 2:
        return <LeadAccountForm 
                onSubmit={(data, isValid = true) => {
                  handleStepSubmit(data, isValid);
                  setIsFormValid(isValid);
                }} 
                initialData={formData.leadAccount} 
              />;
      case 3:
        return <StrategyForm 
                onSubmit={(data) => {
                  handleStepSubmit(data, true);
                  setIsFormValid(true);
                }} 
                initialData={formData.strategy} 
              />;
      case 4:
        return <AccountForm 
                onSubmit={(data, isValid = true) => {
                  handleStepSubmit(data, isValid);
                  setIsFormValid(isValid);
                }} 
                initialData={formData.account} 
              />;
      case 5:
        return <WizardSummary 
                data={formData} 
                onSubmit={handleNext} 
                isSubmitting={isSubmitting} 
              />;
      default:
        return null;
    }
  };

  return (
    <Card className="border-0 shadow-lg">
      <WizardHeader
        stepLabel={stepLabels[currentStep]}
        currentStep={currentStep + 1}
        totalSteps={totalSteps}
      />
      
      <div className="p-6 pt-2">
        {renderStep()}
      </div>
    </Card>
  );
};
